import { Grid } from '@m/alchemy-ui/Grid';
import { GridRow } from '@m/alchemy-ui/GridRow';
import { LoadingIndicator } from '@m/alchemy-ui/LoadingIndicator';

import { SettingsTitle } from 'settings/components/SettingsTitle';
import { useDashboardItems } from 'settings/hooks/useDashboardItems';

import * as Styled from './SettingsDashboard.styled';
import { getDashboardItemComponent } from './SettingsDashboard.utils';

function SettingsDashboardItemsGrid() {
  const { items, loading } = useDashboardItems();

  if (loading) return <LoadingIndicator />;

  return (
    <Grid style={{ maxWidth: 1200, margin: '0 auto' }}>
      <GridRow>
        {items.map(dashboardItem => {
          const Component = getDashboardItemComponent(dashboardItem.id);

          return (
            <Styled.GridColWithMargin
              key={dashboardItem.id}
              span={{ large: 3, medium: 4, small: 12 }}
            >
              <Component
                id={dashboardItem.id}
                title={dashboardItem.title}
                subtitle={dashboardItem.subtitle}
                link={dashboardItem.link}
              />
            </Styled.GridColWithMargin>
          );
        })}
      </GridRow>
    </Grid>
  );
}

export function SettingsDashboard() {
  return (
    <>
      <SettingsTitle>Settings</SettingsTitle>
      <SettingsDashboardItemsGrid />
    </>
  );
}
